import { useRef } from 'react'
import Link from 'next/link'
import animationStyles from 'components/common/Animation/Animation.module.scss'
import useElementVisible from 'components/common/Animation/useElementVisible'
import styles from './CaseCTA.module.scss'

export type CaseCTAItem = {
  title: string | JSX.Element
  description: string | JSX.Element
}

export type CaseCTAProps = CaseCTAItem

const LINK_TEXT = '無料のご相談はこちら'
const LINK_HREF = '/contact/'

const CaseCTA: React.FC<CaseCTAProps> = ({ title, description }) => {
  const animeRef = useRef<HTMLElement>(null)
  const isVisible = useElementVisible(animeRef, 0.1)

  return (
    <section
      className={`${styles.caseCTA} ${animationStyles.fade} ${isVisible ? animationStyles.fadeOn : ''}`}
      ref={animeRef}
    >
      <div className={styles.caseCTA__inner}>
        <div className={styles.caseCTA__layout}>
          <div className={styles.caseCTA__spacer} aria-hidden="true" />
          <div className={styles.caseCTA__body}>
            <dl className={styles.caseCTA__content}>
              <dt className={styles.caseCTA__title}>{title}</dt>
              <dd className={styles.caseCTA__description}>{description}</dd>
            </dl>
            <div className={styles.caseCTA__linkWrap}>
              <Link href={LINK_HREF}>
                <a href={LINK_HREF} className={styles.caseCTA__link}>
                  {LINK_TEXT}
                </a>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default CaseCTA
